import type Environment from '@interfaces/environment.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class TioPatinhasService extends MainService {
  url: string
  GEOIP_URL: string
  logService = new LogService()

  constructor(tioPatinhasUrl?: string) {
    super()
    if (!tioPatinhasUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.tioPatinhas
        this.GEOIP_URL = environment?.exteralApis?.geoip
      })
    } else {
      this.url = tioPatinhasUrl
    }
    this.logService.init('TioPatinhas Service')
  }

  async getIp() {
    try {
      return (await this.http.get(this.GEOIP_URL, { headers: { Accept: 'application/json' } }))?.data?.ip
    } catch (error) {
      return false
    }
  }

  public async canEditProfile() {
    const url = `${this.url}/v1/beneficiaries/self/can-edit`
    const JWT = await this.getJWT()
    const headers = {
      Authorization: `Bearer ${JWT}`,
    }
    return this.http
      .get(url, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error) => {
        this.logService.error({ message: 'Failed to fetch canEditProfile', error: error })
        return {
          data: {
            bank: true,
            canEditNationalDocument: true,
            full: true,
            pis: true,
          },
        }
      })
  }

  public async getNfsImported(month?: number) {
    const headers = await this.getHeaders()

    return this.http
      .get(`${this.url}/v2/nfs${month ? `?month=${month}` : ''}`, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get imported nfs',
          error,
        })
        throw error.response
      })
  }

  public async postAcceptedAntecipationContract(transactionId: string) {
    const headers = await this.getHeaders()

    return this.http
      .post(
        `${this.url}/v2/hub/anticipate/${transactionId}/accepted`,
        {
          ip: await this.getIp(),
          accepted: true,
        },
        { headers }
      )
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on post accepted antecipation contract',
          error,
        })
        throw error.response
      })
  }

  public async postShowAntecipation(transactionId: string) {
    const headers = await this.getHeaders()
    return this.http
      .post(`${this.url}/v2/hub/anticipate/show/${transactionId}`, { show: true }, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on post show antecipation',
          error,
        })
        throw error.response
      })
  }
}
